import {Routes} from "@angular/router";
import {IgDashboardComponent} from "./page/dashboard/ig-dashboard.component";
import {IgConfigPage} from "./page/overview/ig-config/ig-config.page";

export function IgSubRoutes() : Routes {

    /**
     *
     * path:
     * Prefix of the module will always be added to the path name
     *
     *      Example
     *      path: "addresses" => route path "ad/addresses" !
     * ------------------------------------------------------------------
     *
     * canActivate:
     * The authentication guard MsalGuard will be added automatically!
     * ------------------------------------------------------------------
     *
     * component:
     * Added components need to be from type "Page"!
     * ------------------------------------------------------------------
     *
     */
    const routes = [

        {path: 'ig/dashboard', component: IgDashboardComponent},
        {path: 'ig/config', component: IgConfigPage},

    ];

    return routes;

}
